export default "__VITE_ASSET__B4UzU4BW__"